var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tariff',{attrs:{"type":"interview"}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/tariff/interview.vue?vue&type=template&id=7cc64f14&scoped=true
// module id = null
// module chunks = 